import React from 'react';
import { Row, Col, Divider } from 'antd';
import styles from './styles.less';
import usePriceFormat from '../../../utils/priceFormat';
import { LocalizationContext } from '../../../hoc/Localization';

const PaymentAmount: React.FC<{ course: any }> = ({ course }) => {
    const { t } = React.useContext(LocalizationContext);
    const { priceFormat, getCoursePrice } = usePriceFormat();

    const { initial, discount, reward, final } = getCoursePrice(course);

    return (
        <div className={styles.paymentAmountContainer}>
            <Row>
                <Col span={18} className={styles.title}>
                    {t('payment.course.price')}
                </Col>
                <Col span={6}>
                    {initial.currency} {priceFormat(initial.price)}
                </Col>
            </Row>
            {!!discount.amount && (
                <Row>
                    <Col span={18} className={styles.title}>
                        {t('payment.discount')} {!!discount.percent && `${discount.percent}%`}
                    </Col>
                    <Col span={6} className={styles.discountedAmount}>
                        - {initial.currency} {discount.amount}
                    </Col>
                </Row>
            )}
            {!!reward.amount && (
                <Row>
                    <Col span={18} className={styles.title}>
                        {t('payment.bonus')} {reward.percent}%
                    </Col>
                    <Col span={6} className={styles.rewardUseAmount}>
                        - {reward.currency} {priceFormat(reward.amount)}
                    </Col>
                </Row>
            )}
            <Divider className={styles.divider} />
            <Row>
                <Col span={18} className={styles.title}>
                    {t('payment.final.price')}
                </Col>
                <Col span={6} className={styles.finalAmount}>
                    {initial.currency} {priceFormat(final.price)}
                </Col>
            </Row>
        </div>
    );
};

export default PaymentAmount;
